import { Component, computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import { InsightsCardComponent, InsightsComponent } from '@core/impact-tracker-ui';
import { DialogComponentI, IconName } from '@core/user-interface-legacy';

export type InsightsCardData = {
  icon: IconName;
  value: string;
  title: string;
  label: string;
  tooltip: string;
};

export type InsightDialogData = {
  heading: string;
  logoHeading: string;
  subheading: string;
  cards: InsightsCardData[];
};

@Component({
  selector: 'rt-insights-dialog',
  imports: [InsightsComponent, InsightsCardComponent],
  templateUrl: './insights-dialog.component.html',
  styleUrl: './insights-dialog.component.less',
})
export class InsightsDialogComponent implements DialogComponentI<Signal<InsightDialogData>, any> {
  protected route = inject(ActivatedRoute);
  protected data = toSignal(this.route.data);
  protected dialogData = computed(() => <InsightDialogData>this.data()?.dialogData());

  public setDialogData(data: Signal<InsightDialogData>, triggerUpdate: boolean): void {
    if (data) this.dialogData = data;
  }
}
